module.exports = __webpack_public_path__ + "img/device_hub.bb410d7f.svg";